import { StyleSheet, View } from "react-native";
import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import React from "react";
import { ThemedValues } from "styles/themed";
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'

export const listStyles = StyleSheet.create({
	listInCard: {
		backgroundColor: 'white',
		paddingHorizontal: ThemedValues.marginHorizontal,
		paddingVertical: ThemedValues.marginVertical,
	},
	
	listContainer: {
		backgroundColor: 'transparent',
	},
	listItem: {
		margin: 0,
		marginVertical: 5,
		marginHorizontal: 0,
		padding: 0,
		paddingVertical: 4,
		paddingHorizontal: 0,
		height: 'auto',
		backgroundColor: 'transparent'
	},
	
	iconContainer: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
		marginHorizontal: 4
	},
	icon: {
		height: 12,
		width: 12,
		fontSize: 12
	},
	qrcode: {
		height: 24,
		width: 24,
	},
});

export const listArrow = (
	<View
		style={ listStyles.iconContainer }>
		
		<Icon icon={ IconSystemConstants.ARROW_RIGHT } style={ listStyles.icon } color={'#000'} />
	</View>
)

export const qrCode = () => {
	return (
		<View
			style={ listStyles.iconContainer }>
			<FontAwesome5 name="qrcode" style={ listStyles.qrcode } size={listStyles.qrcode.width} color='#000' />
		</View>
	);
}
